import { render, staticRenderFns } from "./ConfirmAdjust.vue?vue&type=template&id=904bb624&"
import script from "./ConfirmAdjust.vue?vue&type=script&lang=js&"
export * from "./ConfirmAdjust.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmAdjust.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports